import { render, staticRenderFns } from "./ServiziView.vue?vue&type=template&id=7b291994&scoped=true&"
import script from "./ServiziView.vue?vue&type=script&lang=js&"
export * from "./ServiziView.vue?vue&type=script&lang=js&"
import style0 from "./ServiziView.vue?vue&type=style&index=0&id=7b291994&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b291994",
  null
  
)

export default component.exports